var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInplayIconMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 66,
    viewBox: "0 0 56 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 66,
    rx: 7,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 31.2679C42.3333 32.0378 42.3333 33.9622 41 34.732L20 46.8564C18.6667 47.6262 17 46.664 17 45.1244L17 20.8756C17 19.336 18.6667 18.3738 20 19.1436L41 31.2679Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInplayIconMini);
export default __webpack_public_path__ + "static/media/InplayIconMini.528ea5e5a1eca23e0f3dea9a0a34b2d8.svg";
export { ForwardRef as ReactComponent };